module.exports = __webpack_public_path__ + "static/img/btlogo-DUhNTl3P.ae3a3d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img2/btlogo-DUhNTl3P.png
// module id = ZqeB
// module chunks = 16